import { type OrderInfo } from 'types/products/productTypes'

export function formatHomeDeliveryAddress(orderInfo: OrderInfo): string | undefined {
  if (!orderInfo?.Address) {
    return
  }

  const { StreetAddress1, StreetAddress2, City, StateCode, Zip } = orderInfo.Address
  return `${StreetAddress1}, ${StreetAddress2 ? `${StreetAddress2},` : ''} ${City}, ${StateCode} ${Zip}`
}
